import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import trimEnd from "lodash/trimEnd";

import routes from "../routes";
import { checkLoginStatus } from "../store/selectors/loginSelector";
import { useTrackingHistory } from "./useTrackingHistory";

import { ConfirmDialog } from "../components/Modals";
import {
  applicationOverviewRoutes,
  detailedAccountRoutes,
  personaSelectionRoutes
} from "../constants";
export const useDisableBrowserBackClick = () => {
  const pushHistory = useTrackingHistory();
  const navigate = useNavigate();
  const location = useLocation();

  const isAgent = useSelector(checkLoginStatus);

  const [isBrowserBackClickConfirmed, setIsBrowserBackClickConfirmed] = useState(false);

  const browserBackEnabledRoutes = [
    "/",
    routes.MyApplications,
    routes.comeBackLoginVerification,
    routes.comeBackLogin,
    routes.finalQuestions,
    routes.login,
    routes.partnerVerification,
    routes.quickapplyLanding,
    routes.applicantInfo,
    routes.searchProspect
  ];
  const isSearchedAppInfoRoute = location.pathname.startsWith(
    trimEnd(routes.SearchedAppInfo, "/:id")
  );

  const isBrowserBackDisabled =
    !browserBackEnabledRoutes.includes(location.pathname) &&
    !applicationOverviewRoutes.includes(location.pathname) &&
    !detailedAccountRoutes.includes(location.pathname) &&
    !personaSelectionRoutes.includes(location.pathname) &&
    !isSearchedAppInfoRoute;

  useEffect(() => {
    if (isBrowserBackDisabled) {
      window.history.pushState(null, null, window.location.href);
      window.addEventListener("popstate", handleBrowserBackButton);
      return () => {
        window.removeEventListener("popstate", handleBrowserBackButton);
      };
    }
  }, [navigate, location.pathname, isBrowserBackDisabled]);

  const handleBrowserBackButton = event => {
    event.preventDefault();
    window.history.go(1);
    if (event.type === "popstate") {
      event.preventDefault();
      setIsBrowserBackClickConfirmed(true);
    }
    return false;
  };

  const handleBackBtnConfirmModal = () => {
    setIsBrowserBackClickConfirmed(false);
    isAgent ? pushHistory(routes.login) : pushHistory(routes.comeBackLogin);
  };
  const showDialogForBrowserBackDisabled = isBrowserBackDisabled && (
    <ConfirmDialog
      isOpen={isBrowserBackClickConfirmed}
      handleReject={() => {}}
      cancelLabel={"Stay on this page"}
      handleClose={() => setIsBrowserBackClickConfirmed(false)}
      message={"You will be logged out of the application!"}
      handleConfirm={() => handleBackBtnConfirmModal()}
      className="browser-back-confirm-dialog"
    />
  );
  return { showDialogForBrowserBackDisabled };
};
